import type { PaAPI } from '@rialtic/types'
import { computed, useRoute } from '#imports'
import { useClaimLab } from '../stores/claimLab'

export const useConnector = () => {
  const route = useRoute()
  const claimLab = useClaimLab()

  const { data: connector } = useApiFetch<PaAPI.Schemas['Connector']>(
    () => `/api/claim-lab/connector/${route.params.connectorId}/connector`,
    {
      headers: claimLab.workspaceId
        ? { 'x-rialtic-workspace-id': claimLab.workspaceId }
        : {},
    },
  )

  const systemDocument = computed(
    () => connector.value?.system_document as Record<string, any> | undefined,
  )

  return { connector, systemDocument }
}
